(() => {
  const sections = document.querySelectorAll('[data-seq-service-areas]');

  if (!sections.length) return;

  const debounce = (callback, delay = 120) => {
    let timer;

    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), delay);
    };
  };

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  sections.forEach((section) => {
    const input = section.querySelector('[data-area-search]');
    const clearButton = section.querySelector('[data-area-clear]');
    const result = section.querySelector('[data-area-result]');
    const cards = Array.from(section.querySelectorAll('[data-suburb-card]'));
    const groups = Array.from(section.querySelectorAll('[data-region-group]'));
    const emptyState = section.querySelector('[data-area-empty]');
    const tabs = section.querySelector('[data-area-tabs]');
    const stickyButton = section.querySelector('[data-mobile-sticky]');
    const hero = section.querySelector('.seq-service-areas__hero');
    const finalSection = section.querySelector('.seq-service-areas__final');
    const total = Number(section.dataset.totalSuburbs || cards.length);

    const restoreCardLabel = (card) => {
      const label = card.dataset.suburbLabel || '';
      const strong = card.querySelector('strong');

      if (strong) strong.textContent = label;
    };

    const highlightMatch = (card, query) => {
      const strong = card.querySelector('strong');
      const label = card.dataset.suburbLabel || '';

      if (!strong || !query) {
        restoreCardLabel(card);
        return;
      }

      const pattern = new RegExp(`(${escapeRegExp(query)})`, 'ig');
      const parts = label.split(pattern);

      strong.replaceChildren(
        ...parts.map((part) => {
          if (part.toLowerCase() === query.toLowerCase()) {
            const mark = document.createElement('mark');
            mark.textContent = part;
            return mark;
          }

          return document.createTextNode(part);
        })
      );
    };

    const applyFilter = () => {
      if (!input) return;

      const query = input.value.trim().toLowerCase();
      const matchingCards = [];

      cards.forEach((card) => {
        const suburbName = card.dataset.suburbName || '';
        const region = (card.dataset.region || '').toLowerCase();
        const isMatch = !query || suburbName.includes(query) || region.includes(query);

        card.classList.toggle('is-hidden', !isMatch);

        if (isMatch) {
          matchingCards.push(card);
          highlightMatch(card, query);
        } else {
          restoreCardLabel(card);
        }
      });

      groups.forEach((group) => {
        const hasVisibleCards = group.querySelector('[data-suburb-card]:not(.is-hidden)');
        group.classList.toggle('is-hidden', !hasVisibleCards);
      });

      if (clearButton) clearButton.hidden = !query;
      if (emptyState) emptyState.hidden = matchingCards.length > 0;

      if (result) {
        if (!query) {
          result.textContent = `${total} published service-area pages across North Brisbane, Moreton Bay and Redcliffe.`;
        } else if (matchingCards.length === 1) {
          const card = matchingCards[0];
          result.textContent = `${card.dataset.suburbLabel} found in ${card.dataset.region}.`;
        } else {
          result.textContent = `${matchingCards.length} matching service areas found.`;
        }
      }

      if (query && matchingCards.length === 1) {
        matchingCards[0].setAttribute('data-exact-result', 'true');
      }

      cards.forEach((card) => {
        if (matchingCards.length !== 1 || card !== matchingCards[0]) {
          card.removeAttribute('data-exact-result');
        }
      });
    };

    const debouncedFilter = debounce(applyFilter);

    if (input) {
      input.addEventListener('input', debouncedFilter);

      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;

        const visibleCards = cards.filter((card) => !card.classList.contains('is-hidden'));

        if (visibleCards.length === 1) {
          event.preventDefault();
          visibleCards[0].click();
        }
      });
    }

    if (clearButton && input) {
      clearButton.addEventListener('click', () => {
        input.value = '';
        input.focus();
        applyFilter();
      });
    }

    if (tabs) {
      tabs.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');

        if (!link) return;

        const target = section.querySelector(link.getAttribute('href'));

        if (!target) return;

        event.preventDefault();

        if (input && input.value) {
          input.value = '';
          applyFilter();
        }

        const headerOffset = parseFloat(
          getComputedStyle(section).getPropertyValue('--seq-header-offset')
        ) || 0;

        const tabsHeight = tabs.offsetHeight;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset - tabsHeight - 12;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      });
    }

    if ('IntersectionObserver' in window && groups.length && tabs) {
      const tabLinks = Array.from(tabs.querySelectorAll('a[href^="#"]'));

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!visibleEntry) return;

          tabLinks.forEach((link) => {
            const isActive = link.getAttribute('href') === `#${visibleEntry.target.id}`;
            link.classList.toggle('is-active', isActive);

            if (isActive) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        },
        {
          rootMargin: '-25% 0px -60% 0px',
          threshold: [0.05, 0.2, 0.5],
        }
      );

      groups.forEach((group) => observer.observe(group));
    }

    const updateSticky = () => {
      if (!stickyButton || !hero) return;

      if (window.matchMedia('(min-width: 769px)').matches) {
        stickyButton.classList.remove('is-visible');
        return;
      }

      const heroPassed = hero.getBoundingClientRect().bottom < 80;
      const finalVisible = finalSection
        ? finalSection.getBoundingClientRect().top < window.innerHeight
        : false;

      stickyButton.classList.toggle('is-visible', heroPassed && !finalVisible);
    };

    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', debounce(updateSticky, 80));
  });
})();
